module.exports = __webpack_public_path__ + "static/media/741MeldrumStNW_2018-06-18_117.5d014cdb.jpg";